(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal
  var reveals=[].slice.call(document.querySelectorAll('.reveal'));
  if(!reduce && 'IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in-view');obs.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -30px 0px'});
    reveals.forEach(function(el){obs.observe(el);});
  } else { reveals.forEach(function(el){el.classList.add('in-view');}); }

  // announcement rotation
  document.querySelectorAll('[data-announcement]').forEach(function(bar){
    var msgs=[].slice.call(bar.querySelectorAll('[data-announcement-message]'));
    if(msgs.length<2 || reduce) return;
    var i=0, speed=(parseInt(bar.getAttribute('data-speed'),10)||4)*1000;
    setInterval(function(){msgs[i].classList.remove('is-active');i=(i+1)%msgs.length;msgs[i].classList.add('is-active');},speed);
  });

  // mobile menu
  var menuBtn=document.querySelector('[data-menu-toggle]');
  var mobileNav=document.querySelector('[data-mobile-nav]');
  if(menuBtn && mobileNav){
    menuBtn.addEventListener('click',function(){var open=mobileNav.classList.toggle('is-open');menuBtn.setAttribute('aria-expanded',String(open));});
    mobileNav.addEventListener('click',function(e){if(e.target.closest('a')){mobileNav.classList.remove('is-open');menuBtn.setAttribute('aria-expanded','false');}});
  }

  // parallax
  var parallax=[].slice.call(document.querySelectorAll('[data-parallax]'));
  if(parallax.length && !reduce){
    var ticking=false;
    function updateParallax(){
      var vh=window.innerHeight;
      parallax.forEach(function(el){var rect=el.getBoundingClientRect();var factor=parseFloat(el.getAttribute('data-parallax'))||0.02;var offset=(rect.top+rect.height/2-vh/2)*factor*-1;offset=Math.max(-55,Math.min(55,offset));el.style.setProperty('--parallax-y',offset.toFixed(1)+'px');});
      ticking=false;
    }
    window.addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(updateParallax);ticking=true;}},{passive:true});
    updateParallax();
  }

  // subtle desktop tilt
  if(!reduce && window.matchMedia('(pointer:fine)').matches){
    document.querySelectorAll('[data-tilt]').forEach(function(card){
      card.addEventListener('pointermove',function(e){var r=card.getBoundingClientRect();var x=(e.clientX-r.left)/r.width-.5;var y=(e.clientY-r.top)/r.height-.5;card.style.transform='perspective(900px) rotateX('+(-y*2.6)+'deg) rotateY('+(x*3.2)+'deg) translateY(-3px)';});
      card.addEventListener('pointerleave',function(){card.style.transform='';});
    });
  }

  // gallery
  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
    var main=gallery.querySelector('[data-product-main-image]'); if(!main) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(btn){btn.addEventListener('click',function(){gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(b){b.classList.remove('is-active');});btn.classList.add('is-active');main.style.opacity='.35';setTimeout(function(){main.src=btn.getAttribute('data-full');main.style.opacity='1';},120);});});
  });

  // quantity
  document.querySelectorAll('[data-qty]').forEach(function(box){
    var input=box.querySelector('[data-qty-input]'); if(!input) return;
    var minus=box.querySelector('[data-qty-minus]'), plus=box.querySelector('[data-qty-plus]');
    if(minus) minus.addEventListener('click',function(){input.value=Math.max(1,(parseInt(input.value,10)||1)-1);input.dispatchEvent(new Event('change',{bubbles:true}));});
    if(plus) plus.addEventListener('click',function(){input.value=(parseInt(input.value,10)||1)+1;input.dispatchEvent(new Event('change',{bubbles:true}));});
  });

  // variant sync / price sync / sticky form
  document.querySelectorAll('[data-product-root]').forEach(function(root){
    var select=root.querySelector('[data-variant-select]');
    var stickyId=root.querySelector('[data-sticky-variant-id]');
    var stickyQty=root.querySelector('[data-sticky-quantity]');
    var qty=root.querySelector('[data-qty-input]');
    var price=root.querySelector('[data-current-price]');
    var compare=root.querySelector('[data-compare-price]');
    var atc=root.querySelector('[data-main-atc]');
    function sync(){
      var id, option;
      if(select){option=select.options[select.selectedIndex];id=select.value;if(price && option.dataset.price) price.textContent=option.dataset.price;if(compare){if(option.dataset.compare){compare.hidden=false;compare.textContent=option.dataset.compare;}else{compare.hidden=true;compare.textContent='';}}if(atc){var ok=option.dataset.available==='true';atc.disabled=!ok;atc.textContent=ok?'Add to Cart':'Sold Out';}}
      else {var single=root.querySelector('[data-single-variant-id]');if(single) id=single.value;}
      if(stickyId && id) stickyId.value=id;
      if(stickyQty && qty) stickyQty.value=qty.value;
    }
    if(select) select.addEventListener('change',sync);
    if(qty) qty.addEventListener('change',sync);
    sync();
  });

  // collection filters
  document.querySelectorAll('[data-product-filters]').forEach(function(filters){
    var grid=document.querySelector('[data-filter-grid]'); if(!grid) return;
    filters.querySelectorAll('[data-filter]').forEach(function(btn){btn.addEventListener('click',function(){var f=btn.getAttribute('data-filter');filters.querySelectorAll('[data-filter]').forEach(function(b){b.classList.remove('is-active');});btn.classList.add('is-active');grid.querySelectorAll('[data-product-card]').forEach(function(card){card.hidden=!(f==='all'||card.getAttribute('data-category')===f);});});});
  });
})();
